module.exports = __webpack_public_path__ + "static/media/404.c2025518.svg";